<template>
    <button
        class="lni-c-button"
        :class="[this.class]"
        type="submit"
        @click="click">{{ text }}</button>
</template>

<script>
import framework from '../../framework';
/**
 *  The x-button component.
 *  @module components/x-button
 */


/**
 * TODO:add description...
 */

export default {
    name: 'x-button',
    mixins: [
        framework.mixins.abstractElement,
    ],
    props: {
        dataText: String,
    },
    computed: {
        text() {
            return this.getAttribute('text', 'Button Text');
        },
        onClickFunction() {
            if (this.dataOnClickFunction) {
                return this.dataOnClickFunction;
            }

            if (this.nodeManifest && this.nodeManifest.attributes.onClickFunction) {
                let func = this.convertInteractionFunction(
                    this.nodeManifest.attributes.onClickFunction);
                if (func) {
                    return func;
                }
            }

            throw new Error('x-button element requires an onClickFunction attribute');
        },
    },
    methods: {
        /**
         * Handles the click event.
         * @param {*} event the click event
         * @returns {void}
         */
        click(event) {
            event.preventDefault();
            this.onClickFunction();
        },
    },
};

</script>



// WEBPACK FOOTER //
// source/components/x-button/x-button.vue